import permissions from 'constants/permissions'

const ORGANIZATION_LIST = [
  {
    name: 'Visualizar',
    tag: permissions.ORGANIZATION.VIEW,
  },
  {
    name: 'Gerenciar',
    tag: permissions.ORGANIZATION.MANAGE,
  },
  {
    name: 'Gerenciar usuários',
    tag: permissions.ORGANIZATION_USER.MANAGE,
  },
  {
    name: 'Visualizar empresas',
    tag: permissions.ORGANIZATION_COMPANY.VIEW,
  },
  {
    name: 'Gerenciar empresas',
    tag: permissions.ORGANIZATION_COMPANY.MANAGE,
  },
]

export default ORGANIZATION_LIST
